import type { RegistryWidgetsType } from '@rjsf/utils';

import { DateEntry } from '@/components/forms/components/form/writer/widgets/dateEntry/dateEntry.writer';
import { withInlineValidation } from '@/components/forms/wrappers/withInlineValidation';
import { CheckboxWidget } from './checkbox/checkbox.writer';
import { CheckboxesWidget } from './checkboxes/checkboxes.writer';
import { CodeEditorWidget } from './codeEditor/codeEditor.writer';
import { GroupSelection } from './groupSelection/groupSelection.writer';
import { MultiSelectMenu } from './multiSelectMenu/multiSelectMenu.writer';
import { NumericInputWidget } from './numericInput/numericInput.writer';
import { Radio } from './radio/radio.writer';
import { SelectMenu } from './selectMenu/selectMenu.writer';
import { SlateWidget } from './slate/slate.writer';
import { TextArea } from './textArea/textArea.writer';
import { TextInput } from './textInput/textInput.writer';
import { EmailInput, UrlInput } from './textInput/typedTextInput.writer';

export const widgets = {
  CheckboxWidget,
  CheckboxesWidget: withInlineValidation(CheckboxesWidget),
  CodeEditorWidget: withInlineValidation(CodeEditorWidget),
  draft: withInlineValidation(SlateWidget),
  NumericWidget: withInlineValidation(NumericInputWidget),
  RadioWidget: withInlineValidation(Radio),
  SelectWidget: withInlineValidation(SelectMenu),
  MultiSelectWidget: withInlineValidation(MultiSelectMenu),
  textarea: withInlineValidation(TextArea),
  TextWidget: withInlineValidation(TextInput),
  EmailWidget: withInlineValidation(EmailInput),
  URLWidget: withInlineValidation(UrlInput),
  'alt-date': withInlineValidation(DateEntry),
  'workflow-group': withInlineValidation(GroupSelection)
} as const satisfies Record<
  string,
  React.FC<any>
> as unknown as RegistryWidgetsType;
